import { Component, effect, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '@ibc-shared/components/header/header.component';
import { TranslateModule } from '@ngx-translate/core';
import { AppReadinessService } from './shared/services/app-readiness/app-readiness.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent, TranslateModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'acfe-telegram-miniapp';
  private appReadinessService = inject(AppReadinessService);

  readonly isAppReady = this.appReadinessService.isAppReady;

  constructor() {
    effect(() => {
      const ready = this.isAppReady();
      console.log('[ACFE] AppComponent: isAppReady changed to', ready);
    });
    console.log('[ACFE] AppComponent: constructor, calling initialize');
    this.appReadinessService.initialize();
  }
}
